// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"4017":"SuperManager","4083":"InstructorManager"}[chunkId] || chunkId) + "." + {"2029":"3e132c47","4017":"39c0f672","4083":"39c0f672","4284":"2da22680","5545":"0ed51e4b"}[chunkId] + ".chunk.css";
};